import { useParams } from 'react-router-dom';
import Payroll from './Payroll';

export default function PayrollGroupDetail() {
  const { id } = useParams();
  return <Payroll detailGroupId={id} />;
}
